<vectronic-filter-header
  [title]="title()"
  (titleClicked)="toggled.emit()"
  (enabledFilterToggle)="toggled.emit()"
  [isFilterEnabled]="expanded()"
></vectronic-filter-header>

<div class="filter-body" [hidden]="!expanded()">
  <mat-form-field appearance="outline">
    <mat-label>After</mat-label>
    <input
      autocomplete="off"
      matInput
      (focus)="pickerAfter.open()"
      (dateChange)="onAfterDateChange($event)"
      [matDatepicker]="pickerAfter"
      class="datepicker"
      [value]="afterDatePickerValue()"
    />
    <mat-datepicker-toggle matSuffix [for]="pickerAfter"></mat-datepicker-toggle>
    <mat-datepicker #pickerAfter></mat-datepicker>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Before</mat-label>
    <input
      autocomplete="off"
      matInput
      (focus)="pickerBefore.open()"
      (dateChange)="onBeforeDateChange($event)"
      [matDatepicker]="pickerBefore"
      class="datepicker"
      [value]="beforeDatePickerValue()"
    />
    <mat-datepicker-toggle matSuffix [for]="pickerBefore"></mat-datepicker-toggle>
    <mat-datepicker #pickerBefore></mat-datepicker>
  </mat-form-field>
</div>
